export default {
    pageSize: 50,
    pageSizeOptions: [20, 50, 100, 500],
};
